import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5c86250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "card-footer" }

import { onBeforeUpdate, onBeforeMount, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'tablet-tile.component',
  props: {
  item: Object,
},
  setup(__props) {

const props = __props



let ScreenshotUrl = ref()

onBeforeMount(() => {
  ScreenshotUrl.value = props.item?.ScreenshotUrl
})

onBeforeUpdate(async () => {
  ScreenshotUrl.value = props.item?.ScreenshotUrl
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    style: _normalizeStyle(!__props.item.Online ? { borderColor: 'red' } : {})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "ss-grid",
        src: 
          _unref(ScreenshotUrl) != undefined
            ? _unref(ScreenshotUrl)
            : require('@/assets/icons/no-image-icon.png')
        ,
        onError: _cache[0] || (_cache[0] = 
          (e) =>
            (e.target.src = `${require('@/assets/icons/no-image-icon.png')}`)
        )
      }, null, 40, _hoisted_2),
      _createElementVNode("span", null, _toDisplayString(__props.item.NameTruncated), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, "Heartbeat: " + _toDisplayString(__props.item.LastHeartbeat), 1)
    ])
  ], 4))
}
}

})